"use strict";

var LoggerInstance = require("js-logger").get("PaymentHelper");

var BluefinHelper = require("./BluefinHelper");
var BraintreeHelper = require("./BraintreeHelper");
var CardConnectHelper = require("./CardConnectHelper");
var CreditCardHelper = require("./CreditCardHelper");
var TokenExHelper = require("./TokenExHelper");
var TsysTsepHelper = require("./TsysTsepHelper");
var Constants = require("../designer/Constants");

var setProperty = (model, propertyName, propertyValue) => {
	var propertyParts = propertyName.split(".");
	var ref = model;
	propertyParts.forEach(function (propertyPart, index) {
		if (index < propertyParts.length - 1) {
			if (!ref[propertyPart]) {
				ref[propertyPart] = {};
			}
			ref = ref[propertyPart];
		} else {
			ref[propertyPart] = propertyValue;
		}
	});
};

//Sometime in the future, we need to figure out how to combine BluefinHelper and DDCPaymentHelper so that when we add additional ones, we can just update the Payment Helper class instead of every place it is used
var PaymentHelper = {
	//parentSelector can be a jQuery object or jQuery selector
	clearPaymentData(parentSelector) {
		if (BluefinHelper.getBluefinIframeId(parentSelector)) {
			BluefinHelper.clearHostedIFrame(parentSelector);
		} else {
			LoggerInstance.debug("clearPaymentData() not implemented for this payment type.");
		}
	},

	initializePaymentComponent($parent) {
		if (BraintreeHelper.isBraintreeCreditCard($parent)) {
			BraintreeHelper.initializeBraintree($parent);
		}

		if (CardConnectHelper.isCardConnect($parent)) {
			CardConnectHelper.initializeCardConnect($parent);
		}

		if (TokenExHelper.isTokenEx($parent)) {
			TokenExHelper.initializeTokenEx($parent);
		}

		if (TsysTsepHelper.isTsysTsep($parent)) {
			TsysTsepHelper.initializeTsysTsep($parent);
		}

		this.initializeEftPayment($parent);
		CreditCardHelper.initializeListeners($parent);
	},

	initializeEftPayment($parent) {
		$parent = $parent || $("body");

		this.disallowSpaceEntry($parent.find("[data-component='eftPayment.accountNumber']"));
		this.disallowSpaceEntry($parent.find("[data-component='eftPayment.routingNumber']"));
		
		var $eftAccountTypeSelectorComponent = $parent.find("[data-component='eftAccountTypeSelector']");
		var defaultEftAccountTypeValue = ($eftAccountTypeSelectorComponent.attr("data-default-eft-account-type") || "CHECKING").toUpperCase();
		$eftAccountTypeSelectorComponent.find(`input[type=radio][value=${defaultEftAccountTypeValue}]`).prop("checked", true)
	},

	disallowSpaceEntry($field) {
		$field.off("keydown.initializeEft");
		$field.on("keydown.initializeEft", (event) => {
			switch (event.which) {
				// Do not allow spaces in the field
				case Constants.KEYS.SPACE:
					return false
				default:
					return true;
			}
		});

		$field.off("change.initializeEft");
		$field.on("change.initializeEft", function(){
			$(this).val($(this).val().replace(/\s/g, ''));
		});
	},

	initializeSaveForLaterCheckbox() {
		// Ensuring that, if the paymentType.savePayment.input should be checked by default, that it is
		$("[data-component='paymentType.savePayment']").each((index, element) => {
			var $savePayment = $(element);
			var $savedPaymentInput = $savePayment.find("[data-component='paymentType.savePayment.input']");

			var defaultCheckedValue = !!$savePayment.attr("data-checked-by-default");

			if ($savedPaymentInput.prop("checked") !== defaultCheckedValue) {
				$savedPaymentInput.prop("checked", defaultCheckedValue);
			}
		});
	},

	//parentSelector can be a jQuery object or jQuery selector
	getPaymentData(wizardCompanyCreditCardErrorMessages, wizardCompanyEftErrorMessages, successCallback, errorCallback, parentSelector) {
		var paymentInformation;

		//Determine which payment type is being used by checking for visibility (extra space in selectors is intentional)
		parentSelector = parentSelector || "body";
		var visibleCCSelector = "[data-payment-type='Credit Card'] :visible";
		var usingCreditCard = $(parentSelector).find(visibleCCSelector).length > 0;
		var visibleEFTSelector = "[data-payment-type='EFT'] :visible";
		var usingEFT = $(parentSelector).find(visibleEFTSelector).length > 0;

		if (BluefinHelper.getBluefinIframeId(parentSelector)) {
			BluefinHelper.getBluefinHostedPageToken(parentSelector, wizardCompanyCreditCardErrorMessages, wizardCompanyEftErrorMessages, (hostedPageTokenObject) => {
				//Need to check to see if there are any other fields that need to be added to the payment information.
				var additionalPaymentData = this._getPaymentFormData(parentSelector);
				if (Object.keys(additionalPaymentData).length) {
					hostedPageTokenObject = Object.assign({}, hostedPageTokenObject, additionalPaymentData);
				}

				successCallback(hostedPageTokenObject);
			}, errorCallback);
			return;
		} else if (usingCreditCard && CardConnectHelper.isCardConnect(parentSelector)) {
			var $element = $(parentSelector).find("[data-component='cardConnectCardNumber']");
			var creditCardNumberToken = CardConnectHelper.getCardConnectToken($element);
			if (creditCardNumberToken) {
				paymentInformation = this._getPaymentFormData(parentSelector, visibleCCSelector);
				paymentInformation.hostedPageToken = creditCardNumberToken;
			}
		} else if (usingCreditCard && TokenExHelper.isTokenEx(parentSelector)) {
			var $tokenExElement = $(parentSelector).find("[data-component='tokenExCardNumber']");
			var tokenExTokenData = TokenExHelper.getTokenExTokenData($tokenExElement);
			if (Object.keys(tokenExTokenData || {}).length) {
				paymentInformation = this._getPaymentFormData(parentSelector, visibleCCSelector);
				paymentInformation.cardType = tokenExTokenData.cardType;
				paymentInformation.last4Digits = tokenExTokenData.lastFour;
				paymentInformation.hostedPageToken = `|TV${tokenExTokenData.token}`;
			}
		} else if (usingCreditCard && TsysTsepHelper.isTsysTsep(parentSelector)) {
			var $element = $(parentSelector).find("[data-component='tsysTsepCreditCardPayment']");
			var result = TsysTsepHelper.getTsysTsepResult($element);
			if (result) {
				paymentInformation = this._getPaymentFormData(parentSelector, visibleCCSelector);

				paymentInformation.hostedPageToken = result.tsepToken;
				paymentInformation.cardType = TsysTsepHelper.getCardType(result.cardType);
				paymentInformation.last4Digits = result.cardNumber.value;
				paymentInformation.expirationDate = result.expirationDate.value;
				paymentInformation.cvv = result.verificationNumber.value;
				paymentInformation.transactionId = result.transactionId;
			}
		} else if (usingCreditCard && BraintreeHelper.isBraintreeCreditCard(parentSelector)) {
			parentSelector = parentSelector || "body";
			var $element = $(parentSelector).find("[data-component='braintreeCreditCardPayment']");
			var result = BraintreeHelper.getBraintreeTokenData($element)
				.done((result) => {
					if (result) {
						paymentInformation = this._getPaymentFormData(parentSelector, visibleCCSelector);

						paymentInformation.hostedPageToken = result.nonce;
						paymentInformation.cardType = result.details.cardType;
						paymentInformation.last4Digits = result.details.lastFour;
						paymentInformation.expirationMonth = result.details.expirationMonth;
						paymentInformation.expirationYear = result.details.expirationYear;
						paymentInformation.cardNumber = paymentInformation.cardType + "-" + paymentInformation.last4Digits;

						successCallback(paymentInformation);
					}
				}).fail(() => {
					var hasAlerted = true;
					errorCallback(hasAlerted);
				});
			return;
		} else if (usingEFT && BraintreeHelper.isBraintreeEft(parentSelector)) {
			paymentInformation = this._getPaymentFormData(parentSelector);
			BraintreeHelper.getEftNonce(parentSelector, paymentInformation, wizardCompanyEftErrorMessages)
				.done(() => {
					if (!Object.keys(paymentInformation || {}).length) {
						errorCallback();
						return;
					}

					delete paymentInformation.accountNumber;
					delete paymentInformation.routingNumber;

					successCallback(paymentInformation);
				})
				.fail((err) => {
					var hasAlerted = true;
					errorCallback(hasAlerted);
				});
			return;
		} else {
			paymentInformation = this._getPaymentFormData(parentSelector);
		}

		if (!Object.keys(paymentInformation || {}).length) {
			errorCallback();
			return;
		}

		successCallback(paymentInformation);
	},

	securePayment(paymentInformation) {
		var deferred = $.Deferred();

		var isSavedPayment = paymentInformation && paymentInformation.savedPaymentId;
		var isZeroDollarTransaction = window.CheckoutActions && (window.CheckoutActions.getTotalAmount() === 0);

		if (isSavedPayment && !isZeroDollarTransaction && paymentInformation.type === "CC" && BraintreeHelper.isBraintreeCreditCard()) {
			BraintreeHelper.getSecuredSavedPayment(deferred, paymentInformation)
		} else {
			deferred.resolve();
		}

		return deferred;
	},

	//parentSelector and selector can be a jQuery object or jQuery selector
	_getPaymentFormData(parentSelector, selector) {
		parentSelector = parentSelector || "body";

		var $paymentForm = $(parentSelector).find(selector || "[data-payment-type='Credit Card'] form:visible,[data-payment-type='EFT'] form:visible");

		var paymentInformation = $paymentForm.serializeArray().reduce((obj, item) => {
			setProperty(obj, item.name, item.value);
			return obj;
		}, {});

		if ($paymentForm.closest("[data-payment-type='Credit Card']").length) {
			paymentInformation.type = "CC";
		} else if ($paymentForm.closest("[data-payment-type='EFT']").length) {
			paymentInformation.type = "EFT";
		}

		return paymentInformation;
	}
};

module.exports = PaymentHelper;



// WEBPACK FOOTER //
// ./Javascript/commonComponents/PaymentHelper.jsx